module.exports = __webpack_public_path__ + "static/media/review.6394943e.svg";